
import { memo } from 'components/lib/react-npm';

const SafeHydrate = ({ children }) => (
    <div suppressHydrationWarning>
        {typeof document === 'undefined' ? null : children}
    </div>
)

export default memo(SafeHydrate);